import { getSkillsIntroductionUrl } from '@/constants';
import { siteConfig } from '@/lib/site';
import React from 'react';
import { useI18n } from '@/hooks/use-i18n';

const UploadDesc: React.FC = () => {
  const { t, currentLanguage } = useI18n('skill');
  const isChinese = currentLanguage === 'zh-CN';

  return (
    <div>
      <div className="text-[14px] text-[#000000BF] flex leading-[24px]">
        <span className={`font-semibold ${!isChinese ? 'min-w-[120px]' : ''}`}>
          {t('upload.importDesc')}
        </span>
        <div className="flex-1">
          {t('upload.importDescContent', { siteName: siteConfig.name })}
          {isChinese && <br />}

          <a
            href={getSkillsIntroductionUrl()}
            target="_blank"
            className="text-[#7171EE] !underline"
          >
            {t('upload.learnMore')}
          </a>
        </div>
      </div>
      <div className="text-[14px] text-[#000000BF] flex leading-[24px]">
        <span className={`font-semibold ${!isChinese ? 'min-w-[120px]' : ''}`}>
          {t('upload.generateDesc')}
        </span>
        <div className="flex-1">
          {t('upload.generateDescContent', { siteName: siteConfig.name })}
        </div>
      </div>
    </div>
  );
};

export default UploadDesc;
